<template>
  <div>
    <material-button
      class="d-none show-modal-connect-allinpay"
      data-bs-toggle="modal"
      data-bs-target="#connectAllinpay"
    ></material-button>
    <div id="custom-overlay" class="custom-modal-overlay"></div>
    <div
      class="modal fade"
      id="connectAllinpay"
      tabindex="-1"
      aria-hidden="true"
      style="z-index: 1056"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Connect Allinpay
            </h5>
            <i
              style="cursor: pointer"
              class="material-icons btn-close-modal"
              data-bs-dismiss="modal"
              aria-label="Close"
              >clear</i
            >
          </div>
          <div class="modal-body" style="overflow-y: unset">
            <div class="group-option-list">
              <label class="fw-bold" for
                >Access Code <span class="text-danger ms-2">*</span></label
              >
              <material-input
                v-model="access_code"
                type="text"
                id="stripe_user_id"
                name="stripe_user_id"
              />
            </div>
            <div class="group-option-list">
              <label class="fw-bold" for
                >Merchant ID <span class="text-danger ms-2">*</span></label
              >
              <material-input
                v-model="auth_mcht_id"
                type="text"
                id="stripe_user_id"
                name="stripe_user_id"
              />
              <div
                class="mt-3 text-danger"
                style="word-break: break-all"
                v-if="messageErr"
              >
                {{ messageErr }}
              </div>
            </div>
            <div class="d-flex justify-content-end mt-5">
              <material-button
                class="mx-2 btn btn-sm btn-background"
                @click="connect()"
              >
                Connect
              </material-button>
              <material-button
                class="mx-2 btn btn-sm btn-background btn-cancel"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                Cancel
              </material-button>
            </div>
          </div>
        </div>
      </div>
      <material-loading :active="loaderActive" />
    </div>
    <div class="position-fixed top-1 end-1 z-index-9999 message-success">
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>
  </div>
</template>
<script>
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import PaymentService from "@/services/payment.service";
import $ from "jquery";

export default {
  name: "connect-allinpay",
  components: {
    MaterialLoading,
    MaterialSnackbar,
    MaterialButton,
    MaterialInput,
  },
  props: {
    keyReload: {
      type: String,
      required: true,
    },
    type: {
      type: Number,
      required: true,
    },
    physicalBranchId: {
      type: Number,
      required: true,
    },
    merchantId: {
      type: Number,
      required: true,
    },
    accessCodeSelected: {
      type: String,
      default: '',
    },
    authMchtIdSelected: {
      type: String,
      default: '',
    },
    getList: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      snackbar: null,
      message: "",
      loaderActive: false,
      access_code: "",
      auth_mcht_id: "",
      messageErr: "",
    };
  },
  methods: {
    connect() {
      if (this.auth_mcht_id == "" || this.auth_mcht_id == null || this.access_code == "" || this.access_code == null) {
        this.messageErr = "Access Code and Merchant ID are required";
        return;
      }

      this.showLoader();
      let dataForm = {
        type: this.type,
        physical_branch_id: this.physicalBranchId,
        merchant_id: this.merchantId,
        access_code: this.access_code,
        auth_mcht_id: this.auth_mcht_id,
      };

      PaymentService.connectAllinpay(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            $(".btn-cancel").click();
            this.snackbar = "success";
            this.message = "Connect Successfully!";
            this.setTimeOutNotification();
            this.getList(1);
          } else {
            this.messageErr = response.data.result.message;
          }
          this.hideLoader();
        },
        (error) => {
          this.messageErr = error.response.data.result.message;
          this.hideLoader();
        }
      );
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
  },
  watch: {
    keyReload() {
      this.access_code = this.accessCodeSelected;
      this.auth_mcht_id = this.authMchtIdSelected;
      this.messageErr = "";
    },
  },
};
</script>
